<template lang="pug">
  #headerComponent( :class="[{'checkout-page': isCheckoutPage},{'bill-page': isOrderPage}]")
    .headerComponent-inner(v-bind:class='{ fixed: headerFixed }')
      .header-left(v-show='!mobile_search')
        .header-logo
          a(v-bind:href='$foodbookConfig.homepage')
            logo-color
        template(v-if="isCheckoutPage || isOrderPage")
          a.continue-shopping(href="#" @click.prevent="gotoShop()")
            svg(width='19' height='17' viewbox='0 0 19 17' fill='none' xmlns='http://www.w3.org/2000/svg')
              path(d='M7.29745 1.28401C7.69085 0.896392 8.32395 0.901082 8.71155 1.29449C9.09925 1.68789 9.09455 2.32104 8.70115 2.70866L3.33075 8.00006H17.002C17.5542 8.00006 18.002 8.44776 18.002 9.00006C18.002 9.55236 17.5542 10.0001 17.002 10.0001H3.33735L8.70115 15.285C9.09455 15.6726 9.09925 16.3058 8.71155 16.6992C8.32395 17.0926 7.69085 17.0973 7.29745 16.7096L0.373253 9.88716C-0.123648 9.39756 -0.123648 8.59596 0.373253 8.10636L7.29745 1.28401Z' fill='#BC2030')
            span Tiếp tục đặt món
      .header-center(v-show='!mobile_search' v-if="!isCheckoutPage && !isOrderPage")
        .shipper-selection(v-if="selectedShipment >= 1 && shipmentSelecting === false")
          shipper(:type='shipments[selectedShipment-1].name' v-if="!isCheckoutPage && !isOrderPage")
          restaurants(v-if="!isCheckoutPage && !isOrderPage")
      .header-right(v-show='!mobile_search')
        hotline(:phone='$foodbookConfig.hotline')
        .search-icon.wiz-hidden(@click='mobile_search = !mobile_search' v-if='visibleSearch')
          a(href='#')
            svg(width='28' height='28' viewbox='0 0 20 20' xmlns='http://www.w3.org/2000/svg')
              circle(fill='none' stroke='#000' stroke-width='1.1' cx='9' cy='9' r='7')
              path(fill='none' stroke='#000' stroke-width='1.1' d='M14,14 L18,18 L14,14 Z')
        .header-login(v-show='false' ref='wzlogin')
          a.btn-login(v-bind:href='$foodbookConfig.loginpage' v-if='!$foodbookConfig.userId')
            | Login
          .login-success(@click='show2 = !show2' v-if='$foodbookConfig.userId')
            img.account-image(alt='Account' src='../assets/images/default-user.png')
            span.account-name {{membership.name}}
            .wz-dropdown(v-show='show2')
              ul.wz-dropdown-nav
                // <li><a :href="$foodbookConfig.customerpage">Your Profile</a></li>
                li
                  a(:href='$foodbookConfig.profilepage') Th&ocirc;ng tin h&#x1ED9;i vi&ecirc;n
                li
                  a(:href='$foodbookConfig.voucherpage') Danh s&aacute;ch voucher
                li
                  a(href='#' @click.prevent='logoutAccount') Logout
        // hideCart
        .header-cart.wiz-visible(v-if='false')
          a(href='#' v-on:click='gotoCheckout')
            span.count {{cart | countTotalItems}}
            span.icon
              img(src='../assets/images/cart.png' alt='Cart')
      .header-search(v-if='mobile_search')
        form.search-area
          input(type='text' placeholder='Search Product' autocomplete='off' v-on:input="$emit('updatesearch', $event.target.value)")
        a.mobile_search_close(href='#' @click='closeSearch')
          svg(width='14' height='14' viewbox='0 0 14 14' xmlns='http://www.w3.org/2000/svg')
            line(fill='none' stroke='#000' stroke-width='1.1' x1='1' y1='1' x2='13' y2='13')
            line(fill='none' stroke='#000' stroke-width='1.1' x1='13' y1='1' x2='1' y2='13')
    .sticky-placeholder(v-bind:style="{ height: '60px', margin: '0px' }" v-if='headerFixed')

</template>

<script>
  import {mapState} from 'vuex'
  import LogoColor from './LogoColor'
  import Hotline from './Hotline'
  import Shipper from './Shipper'
  import Restaurants from './Restaurants'

  export default {
    name: 'Header',
    props: ['hideCenter', 'hideCart', 'visibleSearch', 'headerFixed'],
    components: {
      LogoColor,
      Hotline,
      Shipper,
      Restaurants,
    },
    data() {
      let $today = new Date();
      let dateY = $today.getFullYear();
      let dateM = $today.getMonth() + 1;
      let dateD = $today.getDate();
      if (dateM < 10) dateM = '0' + dateM;
      if (dateD < 10) dateD = '0' + dateD;
      let dateVal = dateY + '-' + dateM + '-' + dateD + ' 00:00:00';

      return {
        dateNow: this.$cart.booking_info ? false : true,
        customDate: this.$cart.booking_info ? true : false,
        show: false,
        show2: false,
        isOpen: false,
        mobile_search: false,
        cart: this.$cart,
        booking_info: this.$cart.booking_info || {
          Book_Date: dateVal,
          Hour: null,
          Minute: null,
          Number_People: -1,
          Note: ""
        },
        buttonText: "DELIVERY NOW",
        logo: this.$foodbookConfig.logo,
        user_id: this.$foodbookConfig.user_phone,
        membership: {},
      };
    },
    computed: {
      ...mapState({
        restaurants: state => state.restaurants.all,
        selectedRestaurant: state => state.restaurants.selected,
        shipments: state => state.shipments.all,
        selectedShipment: state => state.shipments.selected,
        shipmentSelecting: state => state.shipments.selecting,
        expiryDate: state => state.expiryDate
      }),
      isCheckoutPage () { return this.$router.currentRoute.path === '/thanh-toan/' },
      isOrderPage () { return this.$router.currentRoute.path === '/hoa-don/' },
    },
    created() {
      window.addEventListener('click', this.close)
      if (this.dateNow) {
        this.buttonText = "DELIVERY NOW";
      } else {
        let $date = new Date(this.booking_info.Book_Date);
        this.buttonText = $date.getDate() + '/' + ($date.getMonth() + 1) + '/' + $date.getFullYear() + ' ' + this.booking_info.Note;
      }
      if (parseInt(this.user_id)) {
        this.getDataProfile(this.user_id);
      }
    },
    beforeDestroy() {
      window.removeEventListener('click', this.close)
    },
    mounted() {
      if (this.$refs.mapRef) {
        this.$gmapApiPromiseLazy().then(() => {
          var geolocation = {
            lat: 10.780833,
            lng: 106.756944
          };
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: 3000
          });
          this.$refs.mapRef.$autocomplete.setBounds(circle.getBounds());
        });
      }
    },
    methods: {
      gotoShop(){
        window.location.replace('/dat-mon/');
      },
      close(e) {
        if (!this.$refs.wzlogin.contains(e.target)) {
          this.show2 = false;
        }
      },
      setPlace(place) {
        if (place.geometry) {
          this.cart.to_address = place.formatted_address;
          this.cart.longitude = place.geometry.location.lng();
          this.cart.latitude = place.geometry.location.lat();
          localStorage.cart = JSON.stringify(this.cart);
        }
      },
      closeSearch() {
        this.mobile_search = !this.mobile_search;
        this.$emit('updatesearch', '');
      },
      logoutAccount() {
        window.location.replace(this.$foodbookConfig.wpapi + '/logout');
      },
      updateSessionCart() {
        localStorage.cart = JSON.stringify(this.cart);
      },
      gotoCheckout() {
        if (!this.cart.ordersItem.length) {
          this.$toasted.show("Vui lòng chọn sản phẩm bạn muốn mua", {
            position: "top-center",
            duration: 5000,
            type: 'error'
          });
        } else {
          window.location.replace(this.$foodbookConfig.checkoutpage);
        }
      },
      getDataProfile($phone) {
        this.$http.get(this.$foodbookConfig.wpapi + '/membership_detail', {
          params: {
            user_id: $phone
          }
        }).then(response => {
          if (!response.body.data) {
            this.$toasted.show("The system has not been processed yet. Please try again later..", {
              position: "top-center",
              duration: 5000,
              type: 'error'
            });
          } else {
            this.membership = response.body.data;
            if (this.membership.birthday)
              this.membership.birthday = new Date(this.membership.birthday).toISOString();
          }
        }, response => {
          // error callback
          console.log("Error getMembership");
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue